// Small, currency-agnostic integer -> English words helper for the
// optional "Amount in words" line on the A4 invoice template.
const ONES = ["", "One", "Two", "Three", "Four", "Five", "Six", "Seven", "Eight", "Nine", "Ten",
  "Eleven", "Twelve", "Thirteen", "Fourteen", "Fifteen", "Sixteen", "Seventeen", "Eighteen", "Nineteen"];
const TENS = ["", "", "Twenty", "Thirty", "Forty", "Fifty", "Sixty", "Seventy", "Eighty", "Ninety"];

function chunkToWords(n) {
  if (n === 0) return "";
  if (n < 20) return ONES[n];
  if (n < 100) return `${TENS[Math.floor(n / 10)]}${ n % 10 ? " " + ONES[n % 10] : ""}`;
  return `${ONES[Math.floor(n / 100)]} Hundred${n % 100 ? " " + chunkToWords(n % 100) : ""}`;
}

export function numberToWords(amount) {
  const value = Math.round(Math.abs(Number(amount) || 0));
  if (value === 0) return "Zero";

  const groups = [
    { value: 10000000, label: "Crore" },
    { value: 100000, label: "Lakh" },
    { value: 1000, label: "Thousand" },
    { value: 1, label: "" },
  ];

  let remaining = value;
  const parts = [];
  groups.forEach((group) => {
    const count = Math.floor(remaining / group.value);
    if (count > 0) {
      parts.push(`${chunkToWords(count)}${group.label ? " " + group.label : ""}`);
      remaining -= count * group.value;
    }
  });

  return parts.join(" ").trim();
}

export function amountInWords(amount, currencyLabel) {
  const words = numberToWords(amount);
  const suffix = currencyLabel ? ` ${currencyLabel}` : "";
  return `${words}${suffix} Only`;
}
